<mat-expansion-panel hideToggle expanded>
    <div class="panel-title">
        <div class="font--headline" *ngIf="!contactRequested">{{ I18nKeyEnum.HOW_WAS_IT | i18n | async }}</div>
        <div class="font--headline" *ngIf="contactRequested">{{ I18nKeyEnum.THX_TESTING_TITLE | i18n | async }}</div>
    </div>
    <div class="font--subtitle testing-text m-top-big m-bottom-big" *ngIf="contactRequested">{{ I18nKeyEnum.THX_TESTING_TEXT | i18n | async }}</div>

    <form class="flex-c contact-form" [formGroup]='contactForm' *ngIf="!contactRequested">
        <div class="flex-r space-between">
            <div class="rating-btn" *ngFor="let ratingStar of stars;index as i" (click)="onClick(ratingStar)">
                <mat-icon class="rating-icon"
                          [ngClass]="{'rated': contactForm.controls.rating.value >= ratingStar}"
                          [svgIcon]="ICONS.IC_STAR"></mat-icon>
            </div>
        </div>
        <div class="flex-r justify-end font--small" *ngIf="!!contactForm.controls.rating.value">
            {{ I18nKeyEnum.RATED | i18n | async }} {{ contactForm.controls.rating.value }} / {{ stars.length }}
        </div>
        <mat-form-field *ngIf="!!contactForm.controls.rating.value">
            <mat-label>{{ I18nKeyEnum.MORE_FEEDBACK | i18n | async }}</mat-label>
            <textarea matInput formControlName="additionalText"
                      [placeholder]="(I18nKeyEnum.DETAILED_FEEDBACK | i18n | async) || ''"
                      [rows]="2"></textarea>
        </mat-form-field>
        <div class="m-bottom-big font--small-bold">{{ I18nKeyEnum.LETS_CONTINUE | i18n | async }}</div>
        <div class="flex-r contact-row">
            <mat-form-field class="salutation">
                <mat-label>{{ I18nKeyEnum.SALUTATION | i18n | async }}</mat-label>
                <input formControlName="salutation" matInput>
                <mat-error
                        *ngIf="contactForm.controls.salutation.hasError(validatorsErrorEnum.REQUIRED)"
                > {{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="f-grow">
                <mat-label>{{ I18nKeyEnum.FIRST_NAME | i18n | async }}</mat-label>
                <input formControlName="firstName"
                       matInput>
                <mat-error
                        *ngIf="contactForm.controls.firstName.hasError(validatorsErrorEnum.REQUIRED)"
                > {{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="f-grow">
                <mat-label>{{ I18nKeyEnum.LAST_NAME | i18n | async }}</mat-label>
                <input formControlName="lastName" [required]="true" matInput>
                <mat-error
                        *ngIf="contactForm.controls.lastName.hasError(validatorsErrorEnum.REQUIRED)"
                > {{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
                </mat-error>
            </mat-form-field>
        </div>
        <mat-form-field class="">
            <mat-label>{{ I18nKeyEnum.COMPANY | i18n | async }}</mat-label>
            <input formControlName="company" matInput>
        </mat-form-field>
        <mat-form-field class="small">
            <mat-label>{{ I18nKeyEnum.EMAIL | i18n | async }}</mat-label>
            <input [required]="true"
                   formControlName="email"
                   matInput>
            <mat-error
                    *ngIf="contactForm.controls.email.hasError(validatorsErrorEnum.REQUIRED)"
            > {{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
            </mat-error>
        </mat-form-field>
        <button mat-flat-button class="button-base brand-color m-top-big" type="button"
                (click)="getInContact()">{{ I18nKeyEnum.CONTACT_ME_BTN | i18n | async }}
        </button>
    </form>
</mat-expansion-panel>

